import { StyleSheet } from "react-native";
import { styleVars } from "../../app-style-vars";

export default StyleSheet.create({
  pickerContainer: {
    paddingVertical: styleVars.rem(.5),
    paddingLeft: styleVars.rem(4),
    minHeight: styleVars.rem(4),
  },
  iconContainer: {
    width: styleVars.rem(4),
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
  },
  iconWrapper: {
    flex:1,
    flexGrow: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  pickTextContainer: {
    margin: 0,
    paddingHorizontal: 8,
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    alignContent: 'flex-start'
  },
  pickText: {
    fontSize: styleVars.rem(.875),
    color: styleVars.boschDarkBlue
  }
})
